import { render, staticRenderFns } from "./ptStrategy.vue?vue&type=template&id=57ea820e&scoped=true"
import script from "./ptStrategy.vue?vue&type=script&lang=js"
export * from "./ptStrategy.vue?vue&type=script&lang=js"
import style0 from "./ptStrategy.vue?vue&type=style&index=0&id=57ea820e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ea820e",
  null
  
)

export default component.exports